import { BadgeCheck, ShieldCheck, MessageCircle, Clock, CheckCircle2 } from "lucide-react";

// Small, uniform trust badge used on cards + profiles.
export function TrustBadge({ icon: Icon, label, tone = "slate" }) {
  const tones = {
    slate: "bg-slate-100 text-slate-700 border-slate-200",
    blue: "bg-[#2563EB]/8 text-[#2563EB] border-[#2563EB]/20",
    green: "bg-[#10B981]/10 text-[#059669] border-[#10B981]/25",
  };
  return (
    <span className={`inline-flex items-center gap-1 text-[10.5px] font-medium tracking-wide px-2 py-0.5 rounded-full border ${tones[tone]}`}>
      <Icon className="w-3 h-3" strokeWidth={2.4} />
      {label}
    </span>
  );
}

// Row of trust badges — used on both card + profile.
export function TrustRow({ coach, dense = false, testId }) {
  const badges = [];
  if (coach.identity_verified) badges.push({ icon: BadgeCheck, label: "Identity verified", tone: "blue" });
  if (coach.certifications_verified) badges.push({ icon: ShieldCheck, label: "Certified", tone: "green" });
  if ((coach.completed_sessions_count || 0) > 0) {
    badges.push({ icon: CheckCircle2, label: `${coach.completed_sessions_count} completed`, tone: "slate" });
  }
  if (coach.response_time_hours) {
    badges.push({ icon: Clock, label: `Replies < ${coach.response_time_hours}h`, tone: "slate" });
  }
  if (!dense) {
    badges.push({ icon: MessageCircle, label: "Reviews from completed sessions", tone: "slate" });
  }
  return (
    <div data-testid={testId} className="flex flex-wrap gap-1.5">
      {badges.map((b, i) => <TrustBadge key={i} {...b} />)}
    </div>
  );
}
